import { connect } from 'react-redux';

import ResourceAdminAddScreen from '../components/ResourceAdminAddScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.resourcesAdmin.get('isLoading'),
    success: state.resourcesAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const ResourceAdminAddScreenContainer = connect(mapStateToProps)(
  ResourceAdminAddScreen
);

export default ResourceAdminAddScreenContainer;
